const state = {
    itens: [],
    item: {
        name: '',
        commission_reversal_default: 0,
        is_active: false,
        commissions: [],
    },
};

export default state;